// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1eyUs","footer":"ChangeClinic_footer__26VBr"};